

//检测浏览器名称
export let getBrowser = () => {
  var UserAgent = navigator.userAgent.toLowerCase();
  var browserInfo: { type: string; versions: number } = {
    type: '',
    versions: 0,
  };
  var browserArray: any = {
    //@ts-ignore
    IE: window?.ActiveXObject || 'ActiveXObject' in window, // IE
    Chrome:
      UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1, // Chrome浏览器
    Firefox: UserAgent.indexOf('firefox') > -1, // 火狐浏览器
    Opera: UserAgent.indexOf('opera') > -1, // Opera浏览器
    Safari:
      UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') == -1, // safari浏览器
  };
  // console.log(browserArray)
  for (var i in browserArray) {
    if (browserArray[i]) {
      var versions = '';
      if (i == 'IE') {
        versions = UserAgent.match(/(msie\s|trident.*rv:)([\w.]+)/)![2];
      } else if (i == 'Chrome') {
        versions = UserAgent.match(/chrome\/([\d.]+)/)![1];
      } else if (i == 'Firefox') {
        versions = UserAgent.match(/firefox\/([\d.]+)/)![1];
      } else if (i == 'Opera') {
        versions = UserAgent.match(/opera\/([\d.]+)/)![1];
      } else if (i == 'Safari') {
        versions = UserAgent.match(/version\/([\d.]+)/)![1];
      } else if (i == 'Edge') {
        versions = UserAgent.match(/edge\/([\d.]+)/)![1];
      }
      browserInfo.type = i;
      browserInfo.versions = parseInt(versions);
    }
  }
  return browserInfo;
};
//获取操作系统
export let getOperationSys = () => {
  var OS = '';
  var OSArray: any = {};
  var UserAgent = navigator.userAgent.toLowerCase();
  OSArray.Windows =
    navigator.platform == 'Win32' || navigator.platform == 'Windows';
  OSArray.Mac =
    navigator.platform == 'Mac68K' ||
    navigator.platform == 'MacPPC' ||
    navigator.platform == 'Macintosh' ||
    navigator.platform == 'MacIntel';
  OSArray.IOS =
    UserAgent.indexOf('iphone') > -1 ||
    UserAgent.indexOf('ipod') > -1 ||
    UserAgent.indexOf('ipad') > -1;
  OSArray.Android = UserAgent.indexOf('android') > -1;
  for (var i in OSArray) {
    if (OSArray[i]) {
      OS = i;
    }
  }
  return OS;
};

//获取平台id
export let getPlatform = () => {
  let OS = getOperationSys();
  let platform: number = 1;
  //Android=1  IOS=2  WINDOWS/MAC=3
  switch (OS) {
    case 'Windows':
    case 'Mac':
      platform = 3;
      break;
    case 'Android':
      platform = 1;
      break;
    case 'IOS':
      platform = 2;
      break;
  }
  return platform;
};
